import React from 'react'

import { SubwayMarkerIcon } from '@guiker/icons'

import { Marker, MarkerProps } from './Marker'

export const Subway: React.FC<Omit<MarkerProps, 'icon'>> = ({ ...props }) => {
  return <Marker icon={<SubwayMarkerIcon />} {...props} />
}
